module.exports = "/shifts/shift-swap/selectable-shift-row-0d470f.html";